/**
 * Apply the Design System to a single Drupal behavior
 */

// ECMAScript polyfills, but NOT fetch(). Fetch() is web standard, not ECMAScript.
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { enableComponents } from '../../source/default';
import importAll from '../../tools/webpack/import-all';

// Import only specific wizard components
const atomicContext = require.context(
  '../../source/default/_patterns',
  true,
  /^\.\/(02-molecules\/(wizard-application-entrant|wizard-application-professionals|wizard-application-driver|wizard-vacancies|wizard-jobalert-subscription))\/[\w-]+$/
);

const components = importAll(atomicContext);

window.rewe = {
  ...(window.rewe || {}),
  enableComponents: (context) => enableComponents(context, {}, components),
};
